





















































import Vue from 'vue'
import { IOfficeHourDay } from '@/api/types/response.types'

export default Vue.extend({
  name: 'MailboxSettingsOfficeHoursDay',

  props: {
    day: {
      type: Object as () => IOfficeHourDay,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    placeholder(): string {
      return this.day.isOpen ? 'Select time' : 'Closed'
    },
  },

  watch: {
    'day.isOpen'(value) {
      if (value) {
        this.day.openTime = !this.day.openTime ? '9:00am' : this.day.openTime
        this.day.closeTime = !this.day.closeTime ? '5:00pm' : this.day.closeTime
      } else {
        this.day.openTime = null
        this.day.closeTime = null
      }
    },
  },
})
